import { reversalTimeline } from "@/mocks/melonData";

export default function ReversalTimeline() {
  return (
    <section id="reversal" className="bg-gradient-to-b from-secondary-100/50 to-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-600">
              <i className="ri-loop-left-line" /> 深度复盘
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">48 小时反转追踪</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              把一颗瓜的后续按时间铺开。剧情每反转一次，我们都标注阶段与关键动态。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full bg-secondary-100 px-4 py-2 text-xs font-semibold text-secondary-700">
            <i className="ri-flashlight-fill" />
            本期主角：{reversalTimeline.target}
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="relative">
            <img
              src={reversalTimeline.cover}
              alt="S姓选秀C位退团反转追踪复盘图"
              className="w-full rounded-3xl object-cover border-4 border-background-50"
            />
            <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-700">{reversalTimeline.lead}</p>
          </div>

          <ol className="relative space-y-0 border-l-2 border-dashed border-background-300 pl-6">
            {reversalTimeline.steps.map((s, i) => (
              <li key={s.title} className={`relative ${i > 0 ? "pt-7" : ""}`}>
                <span
                  className={`absolute -left-[30px] top-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full ${
                    s.solid ? "bg-primary-500" : "bg-secondary-500"
                  }`}
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                      s.solid ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    {s.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{s.time}</span>
                </div>
                <h3 className="mt-2 text-base font-bold text-foreground-950">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{s.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}